import { render, staticRenderFns } from "./SettingsBlockedSection.vue?vue&type=template&id=669ce601"
import script from "./SettingsBlockedSection.vue?vue&type=script&lang=js"
export * from "./SettingsBlockedSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports